// CheckInAccessGate

import { useState } from "react";
import { checkInConfig } from "../constants/checkInConfig";

export default function CheckInAccessGate({ onAccessGranted }) {
  const [accessCode, setAccessCode] = useState("");
  const [error, setError] = useState("");

  function handleSubmit(event) {
    event.preventDefault();

    const expectedCode = checkInConfig.accessCode;
    const enteredCode = accessCode.trim();

    if (!expectedCode) {
      setError("Check-in access code is not configured.");
      return;
    }

    if (enteredCode !== expectedCode) {
      setError("Invalid access code. Please try again.");
      return;
    }

    setError("");
    onAccessGranted();
  }

  return (
    <main className="event-noise flex min-h-screen items-center justify-center bg-twilight-indigo-950 px-5 py-10 text-white">
      <section className="w-full max-w-xl border border-white/10 bg-twilight-indigo-900/70 p-6 shadow-glow backdrop-blur md:p-8">
        <p className="mb-4 text-xs font-semibold uppercase tracking-[0.4em] text-amber-flame-500">
          ULFA 2026
        </p>

        <h1 className="font-display text-4xl font-bold leading-tight md:text-5xl">
          Staff Check-In Access
        </h1>

        <p className="mt-4 text-sm leading-7 text-slate-300">
          Enter the staff access code to open the event check-in station.
        </p>

        <form onSubmit={handleSubmit} className="mt-8">
          <label
            htmlFor="checkInAccessCode"
            className="mb-3 block text-xs font-semibold uppercase tracking-[0.22em] text-slate-300"
          >
            Access Code
          </label>

          <input
            id="checkInAccessCode"
            type="password"
            value={accessCode}
            onChange={(event) => setAccessCode(event.target.value)}
            placeholder="Enter staff access code"
            className="registration-field w-full border border-white/15 bg-twilight-indigo-950/80 px-5 py-4 text-base text-white outline-none transition placeholder:text-slate-600 focus:border-amber-flame-500"
          />

          {error && (
            <div className="mt-5 border border-burnt-tangerine-500/50 bg-burnt-tangerine-950/40 px-4 py-4 text-sm text-burnt-tangerine-200">
              {error}
            </div>
          )}

          <button
            type="submit"
            className="mt-6 min-h-[56px] w-full bg-amber-flame-500 px-8 py-4 text-xs font-bold uppercase tracking-[0.25em] text-twilight-indigo-950 transition hover:bg-amber-flame-400"
          >
            Open Check-In Station
          </button>
        </form>
      </section>
    </main>
  );
}